import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";

import FlIndex from "@views/fulian/Index";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [{
            path: "/",
            name: "fl_index",
            meta: {
                title: "大亚湾妇联",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: FlIndex
        },
        {
            path: "/cate/list",
            name: "cate_list",
            meta: {
                title: "分类列表",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/CateList.vue")
        },
        {
            path: "/area/list",
            name: "area_list",
            meta: {
                title: "分类列表",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/AreaList.vue")
        },
        {
            path: "/news/list",
            name: "news_list",
            meta: {
                title: "分类列表",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/NewsList.vue")
        },
        {
            path: "/area/news/list",
            name: "area_news_list",
            meta: {
                title: "走进基层",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/AreaNewsList.vue")
        },
        {
            path: "/normal/news/list",
            name: "normal_news_list",
            meta: {
                title: "文章列表",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/NormalNewsList.vue")
        },
        {
            path: "/normal/news/list",
            name: "normal_news_list",
            meta: {
                title: "文章列表",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/NormalNewsList.vue")
        },

        {
            path: "/leader/index",
            name: "leader_index",
            meta: {
                title: "审核列表",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/admin/index.vue")
        },
        {
            path: "/leader/news/:id",
            name: "leader_news",
            meta: {
                title: "文章",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/admin/news.vue")
        },
        {
            path: "/leader/hope",
            name: "leader_hope",
            meta: {
                title: "文章",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/admin/hope.vue")
        },
        {
            path: "/leader/child",
            name: "leader_child",
            meta: {
                title: "文章",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/admin/child.vue")
        },
        {
            path: "/help/index",
            name: "help_index",
            meta: {
                title: "关爱帮扶",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/HelpIndex.vue")
        },
        {
            path: "/help/child/form",
            name: "help_child_form",
            meta: {
                title: "关爱帮扶",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/HelpChildForm.vue")
        },
        {
            path: "/help/child/list",
            name: "help_child_list",
            meta: {
                title: "困境儿童",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/HelpChildList.vue")
        },
        {
            path: "/help/child/info",
            name: "help_child_info",
            meta: {
                title: "困境儿童",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/HelpChildInfo.vue")
        },
        {
            path: "/hope/Index",
            name: "hope_index",
            meta: {
                title: "微心愿",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/HopeIndex.vue")
        },
        {
            path: "/hope/info",
            name: "hope_info",
            meta: {
                title: "微心愿详情",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/HopeInfo.vue")
        },
        {
            path: "/hope/form",
            name: "hope_form",
            meta: {
                title: "微心愿",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/HopeForm.vue")
        },
        {
            path: "/social/serve",
            name: "social_serve",
            meta: {
                title: "社会服务",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/SocialServe.vue")
        },
        {
            path: "/social/serve/child",
            name: "social_serve_child",
            meta: {
                title: "幼儿服务",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/SocialServeChild.vue")
        },
        {
            path: "/social/serve/gov",
            name: "social_serve_gov",
            meta: {
                title: "执委提素",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/SocialServeGov.vue")
        },
        {
            path: "/social/serve/form",
            name: "social_serve_form",
            meta: {
                title: "社会服务",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/fulian/phase_two/SocialServeForm.vue")
        },
		{
		    path: "/rights",
		    name: "rights_index",
		    meta: {
		        title: "妇儿维权",
		        keepAlive: true,
		        footer: true,
		        backgroundColor: "#fff"
		    },
		    component: () =>
		        import ("@views/fulian/phase_two/Rights_Index.vue")
		},
		{
		    path: "/intro",
		    name: "intro_index",
		    meta: {
		        title: "项目介绍",
		        keepAlive: true,
		        footer: true,
		        backgroundColor: "#fff"
		    },
		    component: () =>
		        import ("@views/fulian/phase_two/Intro_Index.vue")
		},
        // {
        //     path: "/",
        //     name: "Index",
        //     meta: {
        //         title: "首页",
        //         keepAlive: true,
        //         footer: true,
        //         backgroundColor: "#fff"
        //     },
        //     component: Index
        // },
        {
            path: "/customer/chat/:id/:productId?",
            name: "CustomerService",
            meta: {
                title: "客服聊天",
                keepAlive: false,
                auth: true
            },
            component: () =>
                import ("@views/user/CustomerService.vue")
        },
        {
            path: "/category/:pid?",
            name: "GoodsClass",
            meta: {
                title: "产品分类",
                keepAlive: true,
                footer: true,
                backgroundColor: "#fff"
            },
            component: Category
        },
        {
            path: "/collection",
            name: "GoodsCollection",
            meta: {
                title: "收藏商品",
                keepAlive: false,
                auth: true
            },
            component: () =>
                import ("@views/shop/GoodsCollection.vue")
        },
        {
            path: "/search",
            name: "GoodSearch",
            meta: {
                title: "搜索商品",
                keepAlive: true,
                backgroundColor: "#fff"
            },
            component: Search
        },
        {
            path: "/news_detail/:id",
            name: "NewsDetail",
            meta: {
                title: "新闻详情",
                keepAlive: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/shop/news/NewsDetail.vue")
        },
        {
            path: "/news_list",
            name: "NewsList",
            meta: {
                title: "新闻",
                keepAlive: true,
                backgroundColor: "#fff"
            },
            component: () =>
                import ("@views/shop/news/NewsList.vue")
        },
        {
            path: "/evaluate_list/:id",
            name: "EvaluateList",
            meta: {
                title: "商品评分",
                keepAlive: true,
                auth: true
            },
            component: () =>
                import ("@views/shop/EvaluateList.vue")
        },
        {
            path: "/goods_evaluate/:id",
            name: "GoodsEvaluate",
            meta: {
                title: "商品评价",
                keepAlive: true,
                auth: true
            },
            component: () =>
                import ("@views/shop/GoodsEvaluate.vue")
        },
        {
            path: "/promotion",
            name: "GoodsPromotion",
            meta: {
                title: "促销单品",
                keepAlive: false
            },
            component: () =>
                import ("@views/shop/GoodsPromotion.vue")
        },
        {
            path: "/hot_new_goods/:type",
            name: "HotNewGoods",
            meta: {
                title: "热门榜单",
                keepAlive: false
            },
            component: () =>
                import ("@views/shop/HotNewGoods.vue")
        },
        {
            path: "/detail/:id",
            name: "GoodsCon",
            meta: {
                title: "商品详情",
                keepAlive: false
            },
            component: () =>
                import ("@views/shop/GoodsCon.vue")
        },
        {
            path: "/shop/storeList/:gonames?",
            name: "StoreList",
            meta: {
                title: "门店列表",
                keepAlive: false
            },
            component: () =>
                import ("@views/shop/StoreList.vue")
        },
        {
            path: "/cart",
            name: "ShoppingCart",
            meta: {
                title: "购物车",
                keepAlive: true,
                footer: true,
                auth: true
            },
            component: ShoppingCart
        },
        {
            path: "/goods_list",
            name: "GoodsList",
            meta: {
                title: "商品列表",
                keepAlive: true
            },
            component: GoodsList
        },
        {
            path: "/register",
            name: "Register",
            meta: {
                title: "注册",
                keepAlive: true
            },
            component: () =>
                import ( /* webpackChunkName: "login" */ "@views/user/Register.vue")
        },
        {
            path: "/change_password",
            name: "ChangePassword",
            meta: {
                title: "修改密码",
                keepAlive: true,
                backgroundColor: "#fff",
                auth: true
            },
            component: () =>
                import ( /* webpackChunkName: "login" */ "@views/user/ChangePassword.vue")
        },
        {
            path: "/retrieve_password",
            name: "RetrievePassword",
            meta: {
                title: "找回密码",
                keepAlive: true
            },
            component: () =>
                import ( /* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue")
        },
        // {
        //     path: "/login",
        //     name: "Login",
        //     meta: {
        //         title: "登录",
        //         keepAlive: true
        //     },
        //     component: () =>
        //         import ( /* webpackChunkName: "login" */ "@views/user/Login.vue")
        // },
        ...module,
        {
            path: "/auth/:url",
            name: "Loading",
            meta: {
                title: " 加载中",
                keepAlive: true
            },
            component: Loading
        },
        {
            path: "*",
            name: "NotDefined",
            meta: {
                title: "页面找不到",
                keepAlive: true,
                home: false,
                backgroundColor: "#F4F6FB"
            },
            component: NotDefined
        }
    ],
    scrollBehavior(to, from) {
        from.meta.scrollTop = window.scrollY;
        return { x: 0, y: to.meta.scrollTop || 0 };
    }
});

const { back, replace } = router;

router.back = function() {
    this.isBack = true;
    back.call(router);
};
router.replace = function(...args) {
    this.isReplace = true;
    replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
    const { title, backgroundColor, footer, home, auth } = to.meta;
    console.log(to.name, form.name);
    if (auth === true && !$store.state.app.token) {
        if (form.name === "Login") return;
        return toLogin(true, to.fullPath);
    }
    document.title = title || process.env.VUE_APP_NAME || "crmeb商城";
    //判断是否显示底部导航
    footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

    //控制悬浮按钮是否显示
    home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

    $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

    if (auth) {
        $store.dispatch("USERINFO").then(() => {
            next();
        });
    } else next();
});

export default router;